
  export default {
    computed: {
      isMobile() {
        return this.$store.getters.getIsMobile;
      },
    },
    methods: {
      hideAgeRestrictedModal() {
        this.$emit('hide-age-restricted-modal', "Age Restricted modal hidden")
      },
      confirmAge() {
        this.$emit('confirm-age', "Confirm age and proceed")
      }
    }
  };
